import { Route, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root";

export const interventionsGHDRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/interventions/ghd",
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
